<app-template *ngIf="loadedServices" [useCard]="false">
    <div class="container">
        <div class="text-center">
        </div>
        <div class="card col-10 col-md-6 col-lg-4 m-auto shadow mt-3 p-2 cardPreRegistration">
            <table class="table table-striped table-borderless" >
                <thead>
                    <tr>
                        <th class="text-center cardPreRegistration">
                            <h2 class="">Pré-credenciamento</h2>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="textCard">
                                <small for="eventName" class=" no-background">Encontro Presencial</small>
                                <input type="text" readonly class="form-control-plaintext cursor-normal" id="eventName" placeholder="Encontro Presencial" value="{{meetingData.name}}">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="textCard">
                                <small for="data" class="no-background">Data</small>
                                <input type="text" readonly class="form-control-plaintext cursor-normal" placeholder="Data" [value]="meetingDate()">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="">
                                <small for="city" class="no-background">Cidade</small>
                                <input type="text" readonly class="form-control-plaintext cursor-normal" id="city" placeholder="Cidade" value="{{meetingData.localityPlace['name']}}">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="">
                                <small for="place" class="no-background">Local</small>
                                <input type="text" readonly class="form-control-plaintext cursor-normal" id="place" placeholder="Local" value="{{meetingData.place}}">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="">
                                <small for="address" class="no-background">Endereço</small>
                                <textarea readonly  class="form-control-plaintext cursor-normal no-resize h-auto">{{meetingData.address}}</textarea>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="row mt-3">
                                <div class="col-9 row m-auto">
                                    <div class="col-6 col-md-6">
                                        <button type="button" (click)="cancel()" class="btn-green btn-sm btn">
                                            Cancelar
                                          </button>
                                    </div>
                                    <div class="col-6 col-md-6">
                                        <button type="button" (click)="submitPreRegistration()  " class="btn-sm btn btn-green">
                                          Confirmar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</app-template>
<app-template   *ngIf="preRegistrationCompleted"  [useCard]="false" >
    <div class="container mb-3">
        <div #confirmationCard class="col-10 col-md-6 col-lg-4 m-auto text-center mt-3 p-2 cardPreRegistration" style="border-radius:20px">
            <div class="text-center print-visible mb-4">
                <h2 class="print-visible">Pré-credenciamento<br>Concluído</h2>
            </div>

            <p class="print-visible mb-0 text-center" style="color: #f59a3e;">Encontro Presencial</p>
            <p class="print-visible mb-0 text-center" style="font-style: italic;">{{preRegistrationData.meeting.name}}</p>
            <p class="print-visible mb-0 text-center">{{preRegistrationData.meeting.place}}</p>
            <p class="print-visible mb-0 text-center">{{preRegistrationData.meeting.address}}</p>
            <p class="print-visible mb-0 text-center">{{preRegistrationData.meeting.localityPlace.name}}</p>

            <div class="mt-4">
                <em class="informacoes print-visible">Apresente o QR Code na entrada e registre sua presença</em>
                <img src="data:image/png;base64,{{preRegistrationData.qrcode}}"  alt="QR Code - Audiências Públicas" class="qr-code img-fluid print-visible">
            </div>
            <div class="mb-3">
                <em class="informacoes-adicionais mb-3 print-visible p-2">Já o encaminhamos para o seu e-mail {{protectExibitionEmail(userInfo.contactEmail ?? null)}}, mas você pode também:</em><br/>
            </div>
            <a type="button" (click)="saveImage()" class="btn btn-sm btn-outline-primary ms-2 action-buttons">
                <span class="iconText">Salvar</span>
                <i class="fas fa-download"></i>
            </a>
            <a type="button" (click)="print()" class="btn btn-sm btn-outline-primary ms-2 action-buttons">
                <span class="iconText">Imprimir</span>
                <i class="fas fa-print"></i>
            </a>
            <p class="print-visible mb-0 text-center">
                <img class="img-fluid print-visible img-logo-es" src="assets/images/brasao.png" >
            </p>
        </div>
    </div>
</app-template>
<app-template  *ngIf="accreditation" title="Credenciamento Concluído" [useCard]="false" >
    <div class="container mb-3">
        <div class="col-10 col-md-6 col-lg-4 m-auto text-center mt-3 p-2 cardAccreditation" style="border-radius:20px">
            <div class="mt-0">
                <h4 class="informacoes print-visible"  style="margin-top: -10px;color: #f59a3e; margin-bottom: 30px;">Apresente o QR Code na recepção</h4>
                <img src="data:image/png;base64,{{preRegistrationData.qrcode}}"  alt="QR Code - Audiências Públicas" class="qr-code img-fluid print-visible">
            </div>
            <p class="print-visible mb-0 text-center" style="color: #f59a3e;margin-top: 30px;">Encontro Presencial</p>
            <p class="print-visible mb-0 text-center" style="font-style: italic;">{{preRegistrationData.meeting.name}}</p>
            <p class="print-visible mb-0 text-center">
                <img class="img-fluid print-visible img-logo-es" src="assets/images/footer_branco.png" >
            </p>
        </div>
    </div>
</app-template>
<canvas #canvas style="display: none;"></canvas>